<div class="cc-banner">
  <p>
    Credit Card Payment is here! Now at HUBX. <span [routerLink]="['/user/credit_cards']">+ Add New Card</span>
  </p>
  <span class="cc-banner__close" (click)="dismiss()"></span>
</div>